import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter',
})
export class SearchFilterPipe implements PipeTransform {
  transform(records: any[], searchTerm: string): any[] {
    if (!records) return [];
    if (!searchTerm) return records;

    searchTerm = searchTerm.toLowerCase();

    return records.filter(
      (record) =>
        record.channel?.toLowerCase().includes(searchTerm) ||
        record.last_message?.toLowerCase().includes(searchTerm) ||
        record.email?.toLowerCase().includes(searchTerm) ||
        record.phone?.toLowerCase().includes(searchTerm) ||
        record.name?.toLowerCase().includes(searchTerm) ||
        record.sender_requirement?.toLowerCase().includes(searchTerm)
    );
  }
}
